import React from 'react';
import { Link } from 'react-router-dom';
import BlogArt from './BlogArt';
import { formatPostDate } from '../../content/blog';
import './BlogCard.css';

/**
 * Standardized blog teaser card, generated from a post object.
 * `featured` renders the wide art-beside-text layout for the newest post.
 */
const BlogCard = ({ post, featured = false }) => (
  <Link
    to={`/blogpost/${post.slug}`}
    className={`blog-card ${featured ? 'blog-card-featured' : ''}`}
  >
    <div className="blog-card-media">
      <BlogArt variant={post.art} />
    </div>

    <div className="blog-card-body">
      <div className="blog-card-chips">
        <span className="blog-card-category">{post.category}</span>
        <span className="blog-card-reading">{post.readingTime} Min. Lesezeit</span>
      </div>

      <h3 className="blog-card-title">{post.title}</h3>
      <p className="blog-card-excerpt">{post.excerpt}</p>

      <div className="blog-card-meta">
        <span className="blog-card-avatar" aria-hidden="true">
          {post.author.charAt(0)}
        </span>
        <span>{post.author}</span>
        <span className="blog-card-dot" aria-hidden="true">·</span>
        <time dateTime={post.date}>{formatPostDate(post.date)}</time>
      </div>

      <span className="blog-card-more" aria-hidden="true">
        Beitrag lesen &rarr;
      </span>
    </div>
  </Link>
);

export default BlogCard;
